<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Randevu"
    }
</script>

<style scoped>

</style>